import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import { dashboardQueryOptions } from './dashboard-query-options';

interface StudentEnrolmentPercentageResponse {
  currentMonth: number;
  lastMonth: number;
  lastMonthUnits: number;
  percentageChange: number;
  changeType: 'increase' | 'decrease' | 'no-change';
}

export interface GetStudentEnrolmentPercentageParams {
  sessionId: string;
}

export const getStudentEnrolmentPercentageAPI = async ({
  sessionId,
}: GetStudentEnrolmentPercentageParams) => {
  const response = await baseAPI.get<StudentEnrolmentPercentageResponse>(
    '/dashboard/metrics/active-students/enrollment-percentage-over-last-month',
    {
      params: {
        sessionId,
      },
    },
  );
  return response.data;
};

export const useGetStudentEnrolmentPercentage = (
  params: GetStudentEnrolmentPercentageParams,
) => {
  return useQuery({
    ...dashboardQueryOptions,
    queryKey: [KEYS.STUDENT_ENROLMENT_PERCENTAGE, params.sessionId],
    queryFn: () => getStudentEnrolmentPercentageAPI(params),
    enabled: !!params.sessionId,
  });
};
